module.exports = __webpack_public_path__ + "static/media/A.b1154d76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/A.svg
// module id = 287
// module chunks = 0